import { SVGAttributes } from "react";

export function CheckIcon(props: SVGAttributes<SVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="6"
      viewBox="0 0 8 6"
      fill="none"
      {...props}
    >
      <path
        d="M7.33317 0.5L2.74984 5.08333L0.666504 3"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
